<template>
  <div>
    <div id="roanna_bot" :style="botStyle">
      <img class="ran_open_btn ran_btn" :src="openImage" alt="質問してください" @click="togglePanel" />
      <div id="roanna_space">
        <iframe :src="iframeSrc" id="af_object"></iframe>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      openFlug: false,
    }
  },
  computed: {
    botStyle() {
      return {
        width: this.openFlug ? "300px" : "",
        height: this.openFlug ? "500px" : "135px",
        left: this.openFlug ? "" : "calc(100% - 320px)",
        right: this.openFlug ? "20px" : "",
        textAlign: this.openFlug ? "" : "left",
        transition: "0.5s",
      }
    },
    openImage() {
      return this.openFlug
        ? "https://site260.ro-an-na.com/chatbot/images/z62e32d8824c36.png"
        : "https://site260.ro-an-na.com/chatbot/images/f62e32d88248b5.png"
    },
    iframeSrc() {
      return `https://site260.ro-an-na.com/chatbot/bot?key=BOT&d=${location.hostname}`
    },
  },
  methods: {
    togglePanel() {
      this.openFlug = !this.openFlug
    },
  },
}
</script>
  
<style scoped>
#roanna_bot {
  width: 300px; /*iボット横幅*/
  height: 135px; /*dボタン高さ＋ eボタン下位置*/
  margin-right: 2%;
  padding: 0;
  bottom: 0;
  /*  left: ; 警告出るのでコメントアウト*/ /*mボット位置*/
  right: 20px; /*mボット位置*/
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  box-sizing: border-box;
  text-align: left; /*fボタン位置*/
}
#roanna_bot img {
  margin-top: 0;
  margin-bottom: 55px; /*eボタン下位置*/
  margin-left: 60%;
  padding: 0;
  box-sizing: border-box;
}
@media only screen and (max-width: 320px) {
  /*iボット横幅 + mボット位置*/
  #roanna_bot {
    margin: 0 auto 0 auto;
    right: 0px;
    left: 0px;
  }
}

#roanna_space {
  margin: 0;
  padding: 0;
  background: #fff;
  border: #4040dd solid 2px;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

#af_object {
  width: 100%;
  height: calc(450px - 89px);
  margin: 0;
  padding: 0;
  vertical-align: bottom;
  border: none;
  overflow: hidden;
  box-sizing: border-box;
}

.ran_btn {
  width: 80px;
  height: 80px;
  vertical-align: bottom;
  cursor: pointer;
  box-sizing: border-box;
  transition: 0.5s;
}

.ran_btn:hover {
  transform: rotate(360deg);
}
</style>